import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';

// Function to get language from URL path (for future use)
// const getLanguageFromPath = (): string | null => {
//   const path = window.location.pathname;
//   if (path.startsWith('/es')) {
//     return 'es';
//   } else if (path.startsWith('/en')) {
//     return 'en';
//   }
//   return null;
// };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      es: {
        translation: esTranslations,
      },
    },
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'aura-language',
      caches: ['localStorage'],
    },

    // React options
    react: {
      useSuspense: false,
    },
  });

const syncDocumentLanguage = (language: string) => {
  if (typeof document === 'undefined') return;

  const normalizedLanguage = language.startsWith('es') ? 'es' : 'en';
  document.documentElement.lang = normalizedLanguage;
  document.documentElement.dir = 'ltr';
};

i18n.on('languageChanged', syncDocumentLanguage);
syncDocumentLanguage(i18n.resolvedLanguage || i18n.language || 'en');

export default i18n;
